import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import authSlice from './slices/authSlice';
import propertiesSlice from './slices/propertiesSlice';
import adminSlice from './slices/adminSlice';
import maintenanceSlice from './slices/maintenanceSlice';
import paymentsSlice from './slices/paymentsSlice';
import chatSlice from './slices/chatSlice';
import notificationsSlice from './slices/notificationsSlice';
import uiSlice from './slices/uiSlice';

// New normalized structure slices
import companiesSlice from './slices/companiesSlice';
import rentalUnitsSlice from './slices/rentalUnitsSlice';
import tenantsSlice from './slices/tenantsSlice';
import rentalUnitTemplatesSlice from './slices/rentalUnitTemplatesSlice';
import rentalUnitUsersSlice from './slices/rentalUnitUsersSlice';
import companyUsersSlice from './slices/companyUsersSlice';
import tenantCodeSlice from './slices/tenantCodeSlice';
import paymentGatewaySlice from './slices/paymentGatewaySlice';
import payeeAccountsSlice from './slices/payeeAccountsSlice';
import reservationSlice from './slices/reservationSlice';
import inventorySlice from './slices/inventorySlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    properties: propertiesSlice,
    admin: adminSlice,
    maintenance: maintenanceSlice,
    payments: paymentsSlice,
    chat: chatSlice,
    notifications: notificationsSlice,
    ui: uiSlice,
    // New normalized structure reducers
    companies: companiesSlice,
    rentalUnits: rentalUnitsSlice,
    tenants: tenantsSlice,
    rentalUnitTemplates: rentalUnitTemplatesSlice,
    rentalUnitUsers: rentalUnitUsersSlice,
    companyUsers: companyUsersSlice,
    tenantCode: tenantCodeSlice,
    paymentGateway: paymentGatewaySlice,
    payeeAccounts: payeeAccountsSlice,
    reservations: reservationSlice,
    inventory: inventorySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
